import React from 'react';
import useStyles from './SteppedBarStyle';

interface Props {
  className?: string;
  currentValue: string;
  targetValue?: string;
  min?: string;
  max?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  warning?: boolean;
}

const SteppedBar = (props: Props) => {
  const classes = useStyles({warning: props.warning});
  const { currentValue, targetValue, className, style, min, max, disabled } = props;
  let compareClass = 'match';
  if (currentValue && targetValue && min !== undefined && max !== undefined) {
    const cV = Number(currentValue);
    compareClass = (cV >= Number(min) && cV <= Number(max)) ? 'match' : 'mismatch';
  } else if (currentValue && targetValue && currentValue !== targetValue) {
    compareClass = 'mismatch';
  }

  return (
    <div className={`${classes.root} ${className || ''}`} style={style}>
      <div className={`gauge risk${currentValue} sliderBgr ${className ? className : ''} ${disabled ? 'disabled' : ''}`}>
        <div className={`bar bgrDark ${disabled ? 'disabled' : ''}`}>&nbsp;</div>
        <div className={`indicator n${currentValue} bgrDark ${compareClass} ${disabled ? 'disabled' : ''}`}>&nbsp;</div>
        {targetValue && <div className={`targetIndicator n${targetValue} ${compareClass}`}>&nbsp;</div>}
        {new Array(10).fill('').map((x, i) => {
          return i + 1 === parseInt(currentValue) ? (
            <div key={`dot2_${i}`} />
          ) : (
            <div key={`dot2_${i}`} className={`dot n${i + 1}`} />
          );
        })}
      </div>
      <div className={'numbers'}>
        {new Array(10).fill('').map((x, i) => (
          <div key={`n_${i}`} className={`${(i + 1).toString() === currentValue ? 'selected' : ''} n${i + 1} ${compareClass} ${disabled ? 'disabled' : ''}`}>
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SteppedBar;
